import React from 'react';
import { useNavigate } from 'react-router-dom';

import { toolTransform } from '@backrs_ui/common-ui';

import {
  StickerCardId,
  useToolCardById,
} from '@backrs_ui/grow-ui/src/pages/Home/hooks/stickerCardMapping';

import { handlePanelNuggetClick } from './nugget.util';
import { NuggetChip } from './NuggetChip';

type ToolChipProps = Readonly<{
  toolId: StickerCardId;
  /** Overrides the tool's own title. */
  label?: React.ReactNode;
  size?: 'lg' | 'xl';
}>;

/**
 * Inline reference to a Backrs tool: its banner image plus its name, clickable into the tool.
 * Tools backed by a structured session activate that session in the chat instead of navigating.
 */
export const ToolChip: React.FC<ToolChipProps> = ({ toolId, label, size }) => {
  const navigate = useNavigate();
  const { getStickerCard } = useToolCardById({ navigate });
  const card = getStickerCard(toolId);

  const handleClick = () => {
    if (card.tool) {
      handlePanelNuggetClick(toolTransform(card.tool), navigate);

      return;
    }

    card.onClick();
  };

  return (
    <NuggetChip
      id={`tool-chip-${toolId}`}
      inline
      image={{ src: card.tool?.banner_media?.media_url ?? card.stickerUrl }}
      label={label ?? card.title}
      size={size}
      onClick={handleClick}
    />
  );
};
